export const ACTION_TYPE = {
  GRANT_ACCESS: 'grantAccess',
  DENY_ALL: 'denyAll',
};

export const NEW_DEVICE_REQUEST_STATUS = {
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
};
